import PropTypes from "prop-types";
// @mui
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";

export default function Pager({
  pageIndex,
  pageCount,
  pageSize,
  totalCount,
  allowedPageSizes,
  showPageSizeSelector,
  onPageChange,
  onPageSizeChange,
  t,
}) {
  const pageSizes =
    allowedPageSizes?.length && !allowedPageSizes.includes(pageSize)
      ? [...allowedPageSizes, pageSize].sort((a, b) => a - b)
      : allowedPageSizes;

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      className="cg-pager"
      sx={{
        px: 1.5,
        py: 0.75,
        minHeight: 48,
        borderTop: theme => `1px solid ${theme.palette.divider}`,
        flexWrap: "wrap",
        rowGap: 1,
      }}
    >
      {showPageSizeSelector && pageSizes?.length ? (
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
        >
          <Typography
            variant="body2"
            sx={{ color: "text.secondary" }}
          >
            {t("gridRowsPerPage")}
          </Typography>
          <Select
            size="small"
            variant="standard"
            disableUnderline
            value={pageSize}
            onChange={event => onPageSizeChange(Number(event.target.value))}
            sx={{ typography: "body2", "& .MuiSelect-select": { py: 0.25 } }}
          >
            {pageSizes.map(size => (
              <MenuItem
                key={size}
                value={size}
              >
                {size}
              </MenuItem>
            ))}
          </Select>
        </Stack>
      ) : null}
      <Typography
        variant="body2"
        sx={{ color: "text.secondary", flex: "1 1 auto" }}
      >
        {totalCount >= 0
          ? t("gridPageInfo", { page: pageIndex + 1, pages: pageCount, count: totalCount })
          : null}
      </Typography>
      {pageCount > 1 ? (
        <Pagination
          size="small"
          shape="rounded"
          color="primary"
          count={pageCount}
          page={pageIndex + 1}
          siblingCount={1}
          onChange={(event, page) => onPageChange(page - 1)}
        />
      ) : null}
    </Stack>
  );
}

Pager.propTypes = {
  pageIndex: PropTypes.number,
  pageCount: PropTypes.number,
  pageSize: PropTypes.number,
  totalCount: PropTypes.number,
  allowedPageSizes: PropTypes.array,
  showPageSizeSelector: PropTypes.bool,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  t: PropTypes.func,
};
